import { IAppState } from '../../../../../AppModulesWrapper';
import { IPromoBannerInfo } from '../types';

export const selectPromoBannerInfo = (state: IAppState): IPromoBannerInfo | undefined =>
  state.servicePickerWidgetV2.promotion?.promoBannerInfo;
